import type { Me } from '@/types';

/**
 * Dev-mode auth bypass. When VITE_DEV_MODE === 'true' the SPA skips MSAL
 * entirely: the App renders as if a fixed user is signed in, the API client
 * sends a plain X-Dev-User header instead of acquiring a token, and the
 * matching backend (DevModeAuthHandler) accepts it. Only used locally.
 */
export const devMode = import.meta.env.VITE_DEV_MODE === 'true';

/**
 * Annotated rather than inferred, so this stays a `Me` as `Me` grows. Untyped, its literal shape
 * became the type of App's `me` — the profile query seeds from it — and every field added to `Me`
 * afterwards read as "does not exist" at the call sites rather than as "absent here".
 *
 * Carries no `features`, deliberately: this is only the value the query STARTS on, and the real
 * profile call still runs and replaces it. Inventing flags here would light up screens locally that
 * the API has switched off.
 */
export const devUser: Me = {
  objectId: '00000000-0000-0000-0000-000000000001',
  displayName: 'Daniel Morris (DEV)',
  email: 'dev@keytravel.local',
  isAdmin: true,
  isAccountManager: true
};
